<template>
  <div class="step2">
    <div class="donar-info">
      <h4>Personal Info</h4>
      <form>
        <input
          type="text"
          :placeholder="trans('first_name')"
          v-model="store.billing_fields.first_name"
          :disabled="store.loading"
          required
        />
        <input
          type="text"
          :placeholder="trans('last_name')"
          v-model="store.billing_fields.last_name"
          :disabled="store.loading"
          required
        />
        <input
          type="email"
          :placeholder="trans('email')"
          v-model="store.billing_fields.email"
          :readonly="is_logged_in && email"
          :disabled="store.loading"
          required
        />
        <input
          type="tel"
          :placeholder="trans('phone')"
          v-model="store.billing_fields.phone"
          :disabled="store.loading"
          onkeyup="this.value=this.value.replace(/[^\d]/,'')"
        />
        <input
          type="text"
          :placeholder="trans('address')"
          v-model="store.billing_fields.address"
          :disabled="store.loading"
        />
        <div v-if="show_anonymous_donation" class="wpcm-checkbox-field">
          <el-checkbox
            v-model="store.billing_fields.anonymous_donation"
            :disabled="store.loading"
          >
            {{ trans('anonymous_donation') }}
          </el-checkbox>
        </div>
        <div v-if="enable_test_card_information && trans('test_card_information')" class="wpcm-test-card-info">
          <p class="wpcm-test-card-text" v-html="trans('test_card_information')"></p>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps(['is_logged_in', 'email', 'show_anonymous_donation', 'enable_test_card_information', 'strings']);

const setValue = (key, val) => {
  store[key] = val;
};
const setBillingValue = (key, val) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if(props.strings) {
    return props.strings[key]
  }
};

onMounted(() => {
  if(props.is_logged_in && props.email) {
      store.billing_fields.email = props.email;
    }
});


</script>